import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { OnChanges } from '@angular/core';

declare var CountUp: any;

@Directive({
  selector: '[count-up]', // Attribute selector
})
export class CountUpDirective implements OnChanges, OnInit, OnDestroy {
  @Input('endVal') value;
  @Input('id') id;
  @Input('includeDecimal') includeDecimal;
  previousValue = 0;
  ready = false;

  constructor() {
    console.log('Hello CountUpDirective Directive');
  }

  ngOnChanges() {
    if (this.ready) {
      this.animate(this.value);
    }
  }

  ngOnInit() {
    this.ready = true;
    this.animate(this.value);
  }

  ngOnDestroy() {
    this.ready = false;
  }

  animate(end) {
    setTimeout(() => {
      if (this.ready) {
        let decimalPlaces = this.includeDecimal == 'false' ? 0 : 2;
        var numAnim = new CountUp(
          this.id,
          this.previousValue,
          end,
          decimalPlaces
        );
        if (!numAnim.error) {
          numAnim.start();
          this.previousValue = end;
        } else {
          console.error(numAnim.error);
        }
      }
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./src/directives/count-up/count-up.ts